import { render } from "./CategoryFourDuplicateDialog.vue?vue&type=template&id=58f1cab6&scoped=true"
import script from "./CategoryFourDuplicateDialog.vue?vue&type=script&lang=ts"
export * from "./CategoryFourDuplicateDialog.vue?vue&type=script&lang=ts"

import "./CategoryFourDuplicateDialog.vue?vue&type=style&index=0&id=58f1cab6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-58f1cab6"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog});
